<template>
  <SearchableModel
    model-name="AiUsage"
    :available-filters="availableFilters"
    :sort-options="sortOptions"
    sort="-created_at"
    :push-state="pushState"
    :search-placeholder="$t('Search by event, exhibitor, model or invocation')"
  >
    <template #header-title>
      <slot name="header-title" />
    </template>
    <template #default="{ models, meta }">
      <AiUsageTotals v-if="meta?.totals" :totals="meta.totals" />
      <AiUsageIndexTable v-if="models" :usages="models" />
    </template>
  </SearchableModel>
</template>

<script setup>
import AiUsageIndexTable from './AiUsageIndexTable.vue'
import AiUsageTotals from './AiUsageTotals.vue'
import SearchableModel from '@/components/searchable-model/SearchableModel.vue'

defineProps({
  availableFilters: {
    type: Array,
    default: () => [],
  },
  pushState: {
    type: Boolean,
    default: false,
  },
})

// Labels are the English keys the listing translates.
const sortOptions = [
  { value: 'created_at', label: 'Date' },
  { value: 'input_tokens', label: 'Input tokens' },
  { value: 'output_tokens', label: 'Output tokens' },
  { value: 'duration_ms', label: 'Duration' },
]
</script>
